const COOKIE_AUTH_FLAG = '__DW_COOKIE_AUTH__';
export function markCookieAuthPending(remember = false) {
    try {
        const store = remember ? localStorage : sessionStorage;
        const clear = remember ? sessionStorage : localStorage;
        store.setItem(COOKIE_AUTH_FLAG, '1');
        clear.removeItem(COOKIE_AUTH_FLAG);
    }
    catch {
        // ignore storage failures
    }
}
export function clearCookieAuthPending() {
    try {
        sessionStorage.removeItem(COOKIE_AUTH_FLAG);
        localStorage.removeItem(COOKIE_AUTH_FLAG);
    }
    catch {
        // ignore storage failures
    }
}
export function hasCookieAuthPending() {
    try {
        return (sessionStorage.getItem(COOKIE_AUTH_FLAG) === '1' ||
            localStorage.getItem(COOKIE_AUTH_FLAG) === '1');
    }
    catch {
        return false;
    }
}
//# sourceMappingURL=cookie-auth.js.map